var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("BaseDropdown", {
    attrs: { modeDropdown: "Custom", opcoesDropdown: _vm.opcoesProfileButton },
    scopedSlots: _vm._u([
      {
        key: "dropdown-trigger",
        fn: function() {
          return [
            _c("button", { attrs: { id: "buttonDropdown" } }, [
              _c("div", { attrs: { id: "containerIconUser" } }, [
                _c("i", {
                  staticClass: "el-icon-user-solid",
                  staticStyle: { "margin-left": "0px", padding: "0.3rem" }
                })
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "ml-1 mr-1", attrs: { id: "nameUser" } },
                [
                  _c("span", { staticClass: "poppins-regular" }, [
                    _vm._v("Olá, ")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "poppins-bold" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.getPrimeiroEUltimoNome(_vm.nameUser)) +
                        "\n        "
                    )
                  ])
                ]
              ),
              _vm._v(" "),
              _c("i", {
                staticClass: "el-icon-arrow-down",
                attrs: { id: "iconArrow" }
              })
            ])
          ]
        },
        proxy: true
      },
      {
        key: "custom-content",
        fn: function() {
          return [
            _c("div", { attrs: { id: "containerDropdown" } }, [
              _c("div", [
                _c("div", { staticClass: "poppins-semibold" }, [
                  _vm._v(_vm._s(_vm.namePerfil))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "poppins-regular text-sm" }, [
                  _vm._v(_vm._s(_vm.emailUser))
                ])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { id: "LineSeparatorDropdown" } }),
              _vm._v(" "),
              _c(
                "div",
                _vm._l(_vm.opcoesProfileButton, function(option, index) {
                  return _c(
                    "el-dropdown-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: option.visible !== false,
                          expression: "option.visible !== false"
                        }
                      ],
                      key: index,
                      attrs: {
                        command: option,
                        disabled: option.disabled,
                        divided: option.divided,
                        icon: option.icon
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "poppins-semibold color-primary" },
                        [_vm._v(_vm._s(option.text))]
                      )
                    ]
                  )
                }),
                1
              ),
              _vm._v(" "),
              _c("div", { attrs: { id: "LineSeparatorDropdown" } }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex-end" },
                [
                  _c("CustomButton", {
                    attrs: {
                      type: "OutlinedButton",
                      StyleSheet: "width: 6rem",
                      text: _vm.ButtonSair.text
                    },
                    on: { click: _vm.ButtonSair.action }
                  })
                ],
                1
              )
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-462b76cb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-462b76cb","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Buttons/ProfileButton/ProfileButton.vue
// module id = null
// module chunks = 